import React from 'react';

interface BrandLogoProps {
  className?: string;
  alt?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  className = '',
  alt = 'Lexora'
}) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/lexora-header-logo-cropped-650.png`}
      alt={alt}
      className={`block object-contain ${className}`}
    />
  );
};

export default BrandLogo;
